export type CertificateType = 'registration' | 'income';

export type CertificateTypeOption = {
	value: CertificateType;
	label: string;
};

export const CERTIFICATE_TYPE_OPTIONS: CertificateTypeOption[] = [
	{value: 'registration', label: 'Справка о постановке на учёт'},
	{value: 'income', label: 'Справка о доходах'},
];

export const DEFAULT_CERTIFICATE_TYPE: CertificateType = 'registration';
